// src/App.js
import React from 'react';
import $ from 'jquery';
import Header from './components/Header';
import Banner from './components/Banner';
import Invite from './components/Invite';
import About from './components/about';
import CallToAction from './components/CallToAction';
import RSVPForm from './components/RSVP';
import Timeline from './components/Timeline';
import Countdown from './components/countdown';
import Gallery from './components/Gallery';
// import Contact from './components/Contact/Contact';
import Team from './components/Team';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="page-wrapper mobile-menu-visible">
      <div class="preloader"></div>
      <Header />
      <Banner />
      <Invite />
      <About />
      <CallToAction />
      <RSVPForm />
      <Timeline />
      <Countdown />
      <Gallery />
      <Team />
      <Footer />
      {/*<Contact />
       */}
    </div>
  );
}

export default App;